<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>月度账单</h4>
    </div> -->
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" style="margin-bottom: 0;">
        <el-form-item label="月度账单号:">
          <el-input v-model="formData.feeMonthNo" placeholder="请输入" size="mini" style="width:135px;vertical-align:top;"></el-input>
        </el-form-item>
        <el-form-item label="仓库名称:">
          <el-select filterable v-model="formData.organizationName" size="mini" placeholder="请选择" clearable>
            <el-option v-for="(item,index) in addKuwei" :key="index" :label="item.tenantName" :value="item.tenantName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账单时间:">
          <el-date-picker v-model="formData.feeTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>-
          <el-date-picker v-model="formData.feeTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <div style="padding: 5px 0 5px 5px;">
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="addremark" v-if="btnFlg[2]">添加备注</el-button>
          <el-button type="primary" size="mini" @click="addpicture" v-if="btnFlg[3]">添加图片</el-button>
          <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[4]">导出</el-button>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="tableComent" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column width="150" label="操作" align="center">
          <template v-slot="scope">
            <el-button type="text" @click="addzhangdan(scope.row,scope.row.feeMonthId)" v-if="btnFlg[5]">月度明细</el-button>
            <el-button type="text" @click="imgShow(scope.row,scope.row.feeMonthId)" v-if="btnFlg[6]">图片</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeMonthNo" label="月度账单号" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeItem" label="费目" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="platformDivideFee" label="平台分账金额" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="dividePerson" label="分账人" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeTime" label="账单时间" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注信息" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remarkPerson" label="备注人" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remarkTime" label="备注时间" align="center" width="200"></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <div class="img_box">
          <el-image :src="item.url" v-for="(item, index) in imgData" :key="index" alt :preview-src-list="bigImg" style="width: 260px; height: 200px;margin-right:15px;margin-bottom:10px" />
        </div>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="添加备注" :close-on-click-modal="false" :visible.sync="addRemark" width="40%" center @close="remarkQX">
        <el-form :inline="true" :model="formRemark" style="width:50%;margin:0 auto;" class="demo-form-inline" ref="formRemark">
          <el-form-item label="备注信息">
            <el-input v-model="formRemark.remark" type="textarea" rows="3" placeholder="请输入备注" maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" size="mini" @click="remarkQD">确定</el-button>
          <el-button type="primary" size="mini" @click="remarkQX">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="添加图片" :close-on-click-modal="false" :visible.sync="addPicture" width="40%" center @close="pictureQX">
        <div style="text-align: center">
          <el-upload class="upload-demo" action="" ref="upload" :on-success="handleAvatarSuccess" :on-change="handleChange" :file-list="fileList" :auto-upload="false" :limit="1" :before-upload="beforeUpload">
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
        </div>
        <div slot="footer">
          <el-button type="primary" size="mini" @click="pictureQD" :disabled="isDisable">确定</el-button>
          <el-button type="primary" size="mini" @click="pictureQX">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getFeeMonthList, addFeeMonthRemark, getImgShow, submitRepairImage } from '@/api/wms-stock'
import { exportExcel } from '@/utils/fileDown.js'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { getAllTenantData } from '@/api/platform-settlement'

export default {
  name: 'monthlyBills',
  data () {
    return {
      formData: {
        feeMonthNo: '',
        organizationName: '',
        feeTimeStart: '',
        feeTimeEnd: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      h: '500px',
      tableData: [],
      xuanzhongArr: null,
      total: 0,
      loading: false,
      addMarkLookBox: false,
      imageD: '',
      imgData: [],
      bigImg: [],
      keHuOptions: [],
      btnFlg: [],
      btnIdArr: ['0130030100', '0130030200', '0130030300', '0130030400', '0130030500', '0130030600', '0130030700'],
      addKuwei: [],
      addRemark: false,
      formRemark: {
        remark: ''
      },
      addPicture: false,
      fileList: [],
      isDisable: false
    }
  },
  methods: {
    getAllTenantData () {
      getAllTenantData().then(res => {
        console.log(res)
        this.addKuwei = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 图片查看
    imgShow (row) {
      this.addMarkLookBox = true
      getImgShow({
        businessId: row.feeMonthId,
        businessType: 'monthly_bills'
      })
        .then((res) => {
          this.imgData = []
          this.imgData = res
          console.log(this.imgData)
          this.bigImg = this.imgData.map(item => item.url)
          console.log(this.bigImg)
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    chaxun () {
      getFeeMonthList(
        {
          ...this.pageInfo,
          ...this.formData
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.xuanzhongArr = null
        })
        .catch(error => {
          this.$message({ message: error.message, type: 'error' })
        })
    },
    chongzhi () {
      this.formData = {}
      this.chaxun()
    },
    addremark () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
      } else {
        this.addRemark = true
      }
    },
    remarkQD () {
      addFeeMonthRemark({ ...this.formRemark, feeMonthId: this.xuanzhongArr.feeMonthId }).then(res => {
        console.log(res)
        this.addRemark = false
        this.formRemark.remark = ''
        this.chaxun()
      })
        .catch(error => {
          this.message.error(error.message)
        })
    },
    remarkQX () {
      this.addRemark = false
      this.formRemark.remark = ''
    },
    addpicture () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
      }
      getImgShow({
        businessId: this.xuanzhongArr.feeMonthId,
        businessType: 'monthly_bills'
      })
        .then((res) => {
          this.imgData = []
          this.imgData = res
          if (this.imgData.length > 4) {
            this.$message.error('图片最多上传五张')
          } else {
            this.addPicture = true
          }
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    pictureQD () {
      this.isDisable = true
      if (this.fileList.length == 0) {
        DonMessage.error('请选择需要上传的图片!')
      } else {
        let imgfile = new FormData()
        for (var i = 0; i < this.fileList.length; i++) {
          imgfile.append('file', this.fileList[i].raw)
        }
        let numId = { id: this.xuanzhongArr.feeMonthId, businessType: 'monthly_bills' }
        imgfile.append('params', JSON.stringify(numId))
        submitRepairImage(imgfile)
          .then(res => {
            DonMessage.success('操作成功!')
            this.addPicture = false
            this.$refs.upload.clearFiles()
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      }
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
      // this.saveChangeMasterPictureS();
    },
    pictureQX () {
      this.addPicture = false
      this.fileList = []
    },
    // 上传图片成功
    handleAvatarSuccess (res, file, fileList) {
      console.log(res, file, fileList)
      this.fileList = fileList
    },
    handleChange (file, fileList) {
      console.log(file, fileList, file.raw.name.substr(-3))
      if (file.name.substr(-3) == 'jpg' || file.name.substr(-3) == 'png') {
        this.fileList = fileList
      } else {
        this.$message.error('请上传图片')
        this.fileList = []
      }
    },
    beforeUpload (file) {
      console.log(file)
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/inventory/exportFeeMonthList',
        { ...this.formData },
        '月度账单'
      )
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.$refs.tabref1.toggleRowSelection(row)
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 账单明细
    addzhangdan (row, val) {
      this.$router.push({
        name: 'monthlyDetail',
        query: {
          feeMonthId: val
        }
      })
      // this.getFeeList(row)
      this.additionalFee = row.additionalFee
      this.deductionFee = row.deductionFee
      this.totalFee = row.totalFee
      this.YStotalFee = row.receivableFee
      this.feeRemark = row.feeRemark
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 195 + 'px'
    this.btnFlg = getBtn(this.btnIdArr, '/monthlyBills')
    this.chaxun()
    this.getAllTenantData()
  }
}
</script>

<style lang="less" scoped>
    .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
</style>
